import { useContext } from "react";

import { AvailableReservationsContext } from "../contexts/AvailableReservationSlotsContext";

export const useAvailableReservations = () => {
  return useContext(AvailableReservationsContext);
};
